(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function limpar(el) {
    // Remove o transform assim que a animação termina. Um transform activo
    // (mesmo translateY(0)) cria um containing block e quebra position:sticky.
    el.classList.remove('apra-reveal', 'is-visible');
    el.style.removeProperty('opacity');
    el.style.removeProperty('transform');
  }

  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll('#MainContent > .shopify-section:not(.apra-reveal-feito)');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          observer.unobserve(el);
          el.classList.add('is-visible');

          var feito = false;
          function terminar() {
            if (feito) return;
            feito = true;
            limpar(el);
          }
          el.addEventListener('transitionend', terminar, { once: true });
          setTimeout(terminar, 1200);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (section) {
      section.classList.add('apra-reveal', 'apra-reveal-feito');
      observer.observe(section);
    });
  }

  function initParallax() {
    if (reduceMotion) return;

    var todos = Array.prototype.slice.call(
      document.querySelectorAll(
        '.hero__media, .media-with-content .media-block img, .media-with-content .media-block video'
      )
    );

    // .hero__media aplica-se tanto ao <picture> como ao <img> lá dentro.
    // Sem este filtro a escala seria aplicada duas vezes (1.12 x 1.12).
    var mediaEls = todos.filter(function (el) {
      return !todos.some(function (outro) {
        return outro !== el && outro.contains(el);
      });
    });

    if (!mediaEls.length) return;

    mediaEls.forEach(function (el) {
      el.classList.add('apra-parallax');
    });

    var ticking = false;

    function update() {
      var vh = window.innerHeight;
      mediaEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var center = rect.top + rect.height / 2;
        var offset = (center - vh / 2) / vh;
        var translate = offset * 36;
        el.style.transform = 'scale(1.12) translateY(' + translate.toFixed(2) + 'px)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function correr() {
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', correr);
  } else {
    correr();
  }

  // As transições de página do tema não voltam a disparar DOMContentLoaded.
  window.addEventListener('pageshow', correr);
})();
